import { getContractingReportData, getEstimateReportData, getGCGRReportData, getProjectReportData } from ".";
import { fetchProjectById } from "../../api/projects";
import { Project } from "../../interfaces/Project";

/** The project the workbook currently holds data for, or undefined when none is loaded. */
export const getLoadedProjectId = async (): Promise<string | undefined> =>
  (await getProjectReportData())[0]?.project_id as string | undefined;

/** The workbook's project, fetched fresh. Undefined when none is loaded or the fetch fails. */
export const fetchLoadedProject = async (): Promise<Project | undefined> => {
  const projectId = await getLoadedProjectId();
  if (!projectId) return undefined;
  const result = await fetchProjectById(projectId, { populate: ["region"] });
  return result.success ? result.data : undefined;
};

/**
 * The GCGR the workbook currently holds data for, or undefined when none is loaded. This is the
 * selection authority for callers that run outside React (report generation, staleness refresh).
 */
export const getLoadedGcgrId = async (): Promise<string | undefined> =>
  (await getGCGRReportData())[0]?.gcgr_id as string | undefined;

export const getLoadedEstimateId = async (): Promise<string | undefined> =>
  (await getEstimateReportData())[0]?.estimate_id as string | undefined;

/** The project whose contracting data the workbook holds, or undefined when none is loaded. */
export const getLoadedContractingProjectId = async (): Promise<string | undefined> =>
  (await getContractingReportData())[0]?.project_id as string | undefined;
